import React from "react";
import App from "./App";
import ReactDOM from 'react-dom/client';


Office.onReady(() => {
  const root = ReactDOM.createRoot(document.getElementById("react-root") as HTMLElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
